import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import HeroBannerImage from '../assets/images/Group1.png';
import ad1 from '../assets/images/ad1.png'
import ad2 from '../assets/images/ad2.png'
import ad3 from '../assets/images/ad3.png'
import ad4 from '../assets/images/ad4.png'
import fitnessbiceps from '../assets/images/fitnessbiceps.png'
import arrowright from '../assets/images/arrow-right.png'


const HeroBanner = () => (
  <Box sx={{ mt: { lg: '21px', xs: '70px' }, ml: { sm: '50px' } }} position="relative" p="20px">
    <Typography color="#FF2625" fontWeight="600" fontSize="26px">FitZone</Typography>
    <Typography fontWeight={700} sx={{ fontSize: { lg: '44px', xs: '40px' } }} mb="23px" mt="30px">
    push yourself, feel proud <br />
      And Do it again
    </Typography>
    <Typography fontSize="22px" fontFamily="Alegreya" lineHeight="35px">
    Looking for a fun and challenging way to get in shape? <br /> Our gym exercises website has everything you need to stay motivated and<br /> inspired.  With our innovative workouts and personalized training plans,<br /> you'll never get bored or hit a plateau.


    </Typography>
    <Stack>
      <a href="#exercises" style={{ marginTop: '45px', textDecoration: 'none', width: '200px', textAlign: 'center', background: '#FF2625', padding: '14px', fontSize: '22px', textTransform: 'none', color: 'white', borderRadius: '17px' }}>Explore Exercises</a>
    </Stack><br /> <br />
    <Typography font-weight={500} sx={{fontSize: '14px', color:'#fff', marginTop: '0', marginBottom:'1rem'}} >Supported by:</Typography>
    <Stack style={{display: 'flex', margin:'0 -15px', alignItems:'center', opacity:'.6', transition:'.5s', flexDirection:'row', gap:'78px'  }}>
    <img src={ad1} alt="hero-ad1" className="ad_img" />
    <img src={ad2} alt="hero-ad2" className="ad_img" />
    <img src={ad3} alt="hero-ad3" className="ad_img" />
    <img src={ad4} alt="hero-ad4" className="ad_img" />
    </Stack>
    <Stack className='dive'>
      <Stack  style={{ display: 'flex', flexWrap: 'wrap', maxwidth: '75%', marginLeft: '-4px', bottom: '0px', marginRight: '-15px', marginBottom:'opx' , zIndex: '3', position: 'relative', width: '975px', height: '100%', flexDirection: 'column'  }}>
        <Stack className='items-container' style={{ maxwidth: '100%', marginLeft: '0', bottom: '0px', marginRight: '0', marginBottom:'0px' , zIndex: '3', position: 'relative', height: '100%', flexDirection:'row' }}>
          <Stack className='items' style={{ display: 'flex', flexWrap: 'wrap', maxwidth: '100%', marginLeft: '0', bottom: '0px', marginRight: '0', marginBottom:'0px' , zIndex: '3', position: 'relative', borderBottomLeftRadius: '20px', borderTopLeftRadius: '20px', backgroundColor: '#fff', padding: '1rem 1.5rem'  }}>
            <img src={fitnessbiceps} alt="" style={{marginBottom:'1.5rem', maxWidth:'25%', verticalAlign:'middle', borderStyle:'none'}}></img>
            <h5 style={{fontSize:'20px', fontWeight:'500', color:'black', lineHeight:'1.2', marginBottom:'0.5rem'}}>Personal Training</h5>
            <Typography style={{fontSize:'16px', fontWeight:'400', color:'#636366', marginTop: '0', marginBottom: '1.5rem'}}>It’s a long estabilished fact that a reader will be distracted by the readable content</Typography>
              <a href='' style={{color:'#1c1c1e', display:'inline-block', backgroundColor: 'initial'}}>
                <Stack style={{textAlign:'center', display:'flex',boxSizing:'border-box', flexDirection:'row'}}>
                  <span style={{color:'#1c1c1e', textDecoration:'none', cursor:'pointer', marginRight:'0.5rem'}}>Learn More</span>  
                  <img src={arrowright} alt="" />
                </Stack>    
              </a>
          </Stack>
          <Stack className='items' style={{ display: 'flex', flexWrap: 'wrap', maxwidth: '100%', marginLeft: '0', bottom: '0px', marginRight: '0', marginBottom:'opx' , zIndex: '3', position: 'relative', backgroundColor: '#bcff5e', padding: '1rem 1.5rem'  }}>
            <img src={fitnessbiceps} alt="" style={{marginBottom:'1.5rem', maxWidth:'25%', verticalAlign:'middle', borderStyle:'none'}}></img>
              <h5 style={{fontSize:'20px', fontWeight:'500', color:'black', lineHeight:'1.2', marginBottom:'0.5rem'}}>Personal Training</h5>
              <Typography style={{fontSize:'16px', fontWeight:'400', color:'#636366', marginTop: '0', marginBottom: '1.5rem'}}>It’s a long estabilished fact that a reader will be distracted by the readable content</Typography>
                <a href='' style={{color:'#1c1c1e', display:'inline-block', backgroundColor: 'initial'}}>
                  <Stack style={{textAlign:'center', display:'flex',boxSizing:'border-box', flexDirection:'row'}}>
                    <span style={{color:'#1c1c1e', textDecoration:'none', cursor:'pointer', marginRight:'0.5rem'}}>Learn More</span>  
                    <img src={arrowright} alt="" />
                  </Stack>    
                </a>
          </Stack>
          <Stack className='items' style={{ display: 'flex', flexWrap: 'wrap', maxwidth: '100%', marginLeft: '0', bottom: '0px', marginRight: '0', marginBottom:'opx' , zIndex: '3', position: 'relative', borderBottomRightRadius: '20px', borderTopRightRadius: '20px', backgroundColor: '#fff', padding: '1rem 1.5rem'  }}>
            <img src={fitnessbiceps} alt="" style={{marginBottom:'1.5rem', maxWidth:'25%', verticalAlign:'middle', borderStyle:'none'}}></img>
              <h5 style={{fontSize:'20px', fontWeight:'500', color:'black', lineHeight:'1.2', marginBottom:'0.5rem'}}>Personal Training</h5>
              <Typography style={{fontSize:'16px', fontWeight:'400', color:'#636366', marginTop: '0', marginBottom: '1.5rem'}}>It’s a long estabilished fact that a reader will be distracted by the readable content</Typography>
                <a href='' style={{color:'#1c1c1e', display:'inline-block', backgroundColor: 'initial'}}>
                  <Stack style={{textAlign:'center', display:'flex',boxSizing:'border-box', flexDirection:'row'}}>
                    <span style={{color:'#1c1c1e', textDecoration:'none', cursor:'pointer', marginRight:'0.5rem'}}>Learn More</span>  
                    <img src={arrowright} alt="" />
                  </Stack>    
                </a>
          </Stack>
          
        </Stack>
        
      </Stack>   
       
    </Stack>
    
    <img src={HeroBannerImage} alt="hero-banner" className="hero-banner-img" />
  </Box>
);

export default HeroBanner;
